export enum IntervalType {
    Days = 0,
    Months = 1,
    Years = 2,
}
